import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {WindowRefService} from './../window-ref.service';

const routes = {
    voucher: '/voucher',
};
@Injectable({
    providedIn: 'root'
})
export class VoucherService {
    constructor(private apiService: ApiService, private winRef: WindowRefService) {
    }

    /**
     * check voucher
     */
    checkVoucher(voucher: string, rooms: Array<{id: number, price: number}>, start, end, idetab: number = this.winRef.appConfigSite.idEtab) {
        let params = {voucher, rooms, start, end, idetab};
        //let params = {voucher: voucher, rooms: rooms, start: start, end: end, idetab: idetab};
        return this.apiService.post(routes.voucher, params)
            .pipe(map((res: any) => {
                return res
            }));
    }

}
